/**
 * Vehicles API — mirrors `cargoVehicles.js`. Driver registers a vehicle
 * before creating trips; admin verifies later.
 */
import { api } from './client';
import type { Vehicle, VehicleType } from '@/types/trip';

export interface CreateVehicleInput {
  vehicleType: VehicleType;
  brand: string;
  model: string;
  year?: number;
  color?: string;
  plateNumber: string;
  maxWeightKg?: number;
  maxVolumeCbm?: number;
  cargoSpace?: string;
  hasRefrigeration?: boolean;
  hasInsurance?: boolean;
  insuranceExpiry?: string;
  registrationExpiry?: string;
  photos?: string[];
}

function unwrap<T>(res: { data?: any }): T {
  return (res.data?.data ?? res.data) as T;
}

export const vehiclesApi = {
  async listMy(): Promise<Vehicle[]> {
    const r = await api.get(`/api/cargo/vehicles/my`);
    return unwrap<Vehicle[]>(r);
  },
  async findById(id: number): Promise<Vehicle> {
    const r = await api.get(`/api/cargo/vehicles/${id}`);
    return unwrap<Vehicle>(r);
  },
  async create(input: CreateVehicleInput): Promise<Vehicle> {
    const r = await api.post(`/api/cargo/vehicles`, input);
    return unwrap<Vehicle>(r);
  },
  async update(id: number, input: Partial<CreateVehicleInput>): Promise<Vehicle> {
    const r = await api.put(`/api/cargo/vehicles/${id}`, input);
    return unwrap<Vehicle>(r);
  },
  async remove(id: number): Promise<void> {
    await api.delete(`/api/cargo/vehicles/${id}`);
  },
};
